import React from "react";
import "./index.scss";
import { Grid, Typography } from "@mui/material";
const FAQ = () => {
  const faqList = [
    "Genuine parts are manufactured to original specifications, ensuring high quality and reliability.",
    "SIMPARTS are designed specifically for an engine model, meaning they fit better and function more effectively than the Pirate parts.",
    "Genuine parts typically have a longer lifespan, reducing the need for frequent replacements.",
    "Genuine parts come with warranties, providing peace of mind and protection against defects.",
    "Genuine parts meet stringent safety standards, reducing the risk of damage to your machine.",
    "SIMPARTS contribute to optimal performance, helping your vehicle operate as intended.",
    "Using genuine parts may also provide access to better customer support and resources from the manufacturer.",
    "Minimize downtime and maintain good performance, comfort, and convenience by choosing genuine SIMPARTS.",
  ];
  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Home</p>
        <p className="section-name">FAQ</p>
      </div>
      <div className="faq-con">
        <Grid container>
          <Grid item md={2}>
            <p className="parts-heading p-margin-0">What are Genuine Parts?</p>
          </Grid>
          <Grid item md={10}>
            <div>
              <p className="parts-desc p-margin-0">
                Genuine parts, often referred to as manufacturer parts, are
                components made by the original manufacturer of a product. These
                parts are designed to meet the same specifications and quality
                standards. Using genuine parts ensures compatibility,
                reliability, and often better performance compared to
                aftermarket or generic alternatives.
              </p>
            </div>
            <Typography
              variant="h6"
              sx={{
                marginTop: 3,
                borderTop: "1px solid #D8D8D8",
                borderBottom: "1px solid #D8D8D8",
                p: "0.5rem 0px",
                fontWeight: 600,
                marginBottom: 1,
              }}
            >
              ADVANTAGES OF GENUINE SPARES :
            </Typography>
            <div className="list-con">
              {faqList?.map((ele, index) => {
                return (
                  <p className="faq-points">
                    <span className="points-count">{index + 1}.</span> {ele}
                  </p>
                );
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default FAQ;
